/*
 * @Author: wangyan1
 * @Description:
 * @Date: 2022-04-22 11:41:00
 * @LastEditTime: 2022-07-25 15:18:55
 * @FilePath: /teacher-xkh-web/src/service/groupManage/index-url.js
 */
let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/xkh/teacherapi'
} else {
  baseUrl = '//xkhteacher.aixuexi.com/xkh/teacherapi'
}

export default {
  // 我的小组列表
  getGroupList: `${baseUrl}/course/mygroup`,
  // 组内学生列表
  getIntragroupStudent: `${baseUrl}/course/intragroup/student`,
  // 组内学生列表
  getStudentCorrection: `${baseUrl}/correction/student/lessonCount`,
  // 新增学员
  addNewStudent: `${baseUrl}/correction/student/newAdd`,
  // 学员详情讲次列表
  getStudentLessons: `${baseUrl}/student/lesson/list`,
  // 学员详情查询讲次
  getStudentPathlog: `${baseUrl}/correction/student/pathlog`,
  // 学员详情查询讲次
  // getStudentLessons: `${baseUrl}/correction/student/lessonCount`
  // 隐藏小组
  hideGroup: ({ groupId, status }) => `${baseUrl}/course/hide/group/${groupId}/${status}`
}
